// extracted by mini-css-extract-plugin
module.exports = {"loading":"DownloadBonusReports__loading--3K4Ed","button":"DownloadBonusReports__button--1PN_k"};